<div class="dashboard_main">
  <div
    class="header"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    fxLayout.xs="column"
    fxLayoutAlign.xs="space-between center"
  >
    <div fxLayout="row" fxLayoutAlign="center center">
      <mat-icon class="logo-icon"> dashboard </mat-icon>
      <span class="header-title"> Tobacco Cessation </span>
    </div>
    <div fxLayoutGap="10px">
      <button
        class="bd-color btn-white"
        mat-stroked-button
        [matMenuTriggerFor]="menu"
      >
        <mat-icon>download</mat-icon>DOWNLOAD
      </button>
      <button (click)="updateDashboard()" color="primary" mat-raised-button>
        <mat-icon>refresh</mat-icon>REFRESH
      </button>
    </div>
    <mat-menu
      class="menu-custom"
      #menu="matMenu"
      yPosition="below"
      xPosition="before"
    >
      <button mat-menu-item (click)="downloadCSV()">
        <mat-icon>assessment</mat-icon>CSV
      </button>
      <button mat-menu-item (click)="openDashboardPdfPreview()">
        <mat-icon>picture_as_pdf</mat-icon> PDF
      </button>
    </mat-menu>
  </div>

  <!-- // Top Header end here  -->

  <section class="card-wrapper filter-section" fxLayout>
    <mat-card fxFlex>
      <div
        class="card-filter"
        fxLayout
        fxLayout.lt-lg="column"
        fxLayoutGap="20px"
        fxLayoutAlign="start center"
        fxLayoutAlign.lt-lg="start stretch"
      >
        <!-- // Select input  -->
        <mat-form-field fxFlex="25%" fxFlex.lt-lg="40%" appearance="fill">
          <mat-label>Duration</mat-label>
          <mat-select
            (selectionChange)="updateDashboard()"
            [(ngModel)]="selectedValue"
            name="food"
          >
            <mat-option
              *ngFor="let filter of filterOptions"
              [value]="filter.value"
            >
              {{ filter.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- // Custom Date range  -->

        <mat-form-field
          *ngIf="selectedValue === 7"
          fxFlex="25%"
          fxFlex.lt-lg="50%"
          appearance="fill"
          (click)="picker.open()"
        >
          <mat-label>Date range</mat-label>
          <mat-date-range-input
            [formGroup]="range"
            [rangePicker]="picker"
            [max]="todayDate"
          >
            <input
              readonly
              matStartDate
              formControlName="start"
              placeholder="Start date"
            />
            <input
              readonly
              matEndDate
              formControlName="end"
              placeholder="End date"
            />
          </mat-date-range-input>
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-date-range-picker
            #picker
            [disabled]="false"
          ></mat-date-range-picker>

          <mat-error
            *ngIf="range.controls.start.hasError('matStartDateInvalid')"
            >Invalid start date</mat-error
          >
          <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')"
            >Invalid end date</mat-error
          >
        </mat-form-field>

        <!-- /// Health Facility mat-select  -->
        <mat-form-field fxFlex="25%" fxFlex.lt-lg="40%" appearance="fill">
          <mat-label>Health Facility</mat-label>
          <mat-select
            [disabled]="+this.userTypeId > 2"
            (selectionChange)="updateDashboard()"
            [(ngModel)]="selectedhealthFacilityId"
            name="food"
          >
            <mat-option>
              <ngx-mat-select-search
                [formControl]="healthFacilitySearchControl"
                placeholderLabel="Find health facilities..."
                noEntriesFoundLabel="no matching health facilities found..."
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option
              *ngFor="let facility of filterHealthFacilitiesList"
              [value]="facility.id"
            >
              {{ facility.name
              }}{{ facility.id !== -5 ? ", " + facility.levelTwoName : "" }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-card>
  </section>

  <section class="card-wrapper mt-0" fxLayout="column" fxLayoutGap="2.5%">
    <!-- // 1st ROw  -->
    <div
      fxLayout
      fxLayoutAlign="stretch stretch"
      fxLayout.lt-lg="column"
      fxLayoutAlign.lt-lg="start stretch"
      fxLayoutGap="1.5%"
    >
      <!-- // Tobacco users card  -->
      <mat-card fxFlex="33%" fxFlex.lt-lg="100%" fxLayout="column">
        <div class="mat-body-1 mb-20">
          TOTAL -
          <span class="fw500">{{ tobaccoPatientsData.totalPatients }}</span>
        </div>
        <div
          class="primary-dark-text"
          fxLayout
          fxLayoutAlign="start flex-end"
          fxLayoutGap="10px"
        >
          <h3 fxFlex.lt-lg="15">
            {{ tobaccoPatientsData.percentage | number: '1.0-0' }}%
          </h3>
          <h6>Tobacco Users</h6>
        </div>
        <div class="mt-10" fxLayout fxLayoutGap="35px">
          <div>
            <p>Daily</p>
            <div class="mat-body-1 mt-10">
              {{ tobaccoPatientsData && tobaccoPatientsData.totalNumber ? tobaccoPatientsData.totalNumber[0]  : ''}} Total
            </div>

            <div fxLayout fxLayoutGap="10px">
              <div fxLayout fxLayoutGap="5px">
                <h4>{{ tobaccoPatientsData.maleNumber ? tobaccoPatientsData.maleNumber[0] : '' }}</h4>
                <mat-icon class="man-ico">man</mat-icon>
              </div>
              <div fxLayout fxLayoutGap="5px">
                <h4>{{ tobaccoPatientsData.femaleNumber ? tobaccoPatientsData.femaleNumber[0] : '' }}</h4>
                <mat-icon class="woman-ico">woman</mat-icon>
              </div>
            </div>
          </div>
          <div>
            <p>Sometimes</p>
            <div class="mat-body-1 mt-10">
              {{ tobaccoPatientsData.totalNumber ? tobaccoPatientsData.totalNumber[1]  : ''}} Total
            </div>

            <div fxLayout fxLayoutGap="10px">
              <div fxLayout fxLayoutGap="5px">
                <h4>{{ tobaccoPatientsData.maleNumber ? tobaccoPatientsData.maleNumber[1] : ''}}</h4>
                <mat-icon class="man-ico">man</mat-icon>
              </div>
              <div fxLayout fxLayoutGap="5px">
                <h4>{{ tobaccoPatientsData.femaleNumber ? tobaccoPatientsData.femaleNumber[1] : '' }}</h4>
                <mat-icon class="woman-ico">woman</mat-icon>
              </div>
            </div>
          </div>
          <div>
            <p>No</p>
            <div class="mat-body-1 mt-10">
              {{ tobaccoPatientsData.totalNumber ?  tobaccoPatientsData.totalNumber[2] : '' }} Total
            </div>

            <div fxLayout fxLayoutGap="10px">
              <div fxLayout fxLayoutGap="5px">
                <h4>{{ tobaccoPatientsData.maleNumber ? tobaccoPatientsData.maleNumber[2] : '' }}</h4>
                <mat-icon class="man-ico">man</mat-icon>
              </div>
              <div fxLayout fxLayoutGap="5px">
                <h4>{{ tobaccoPatientsData.femaleNumber ? tobaccoPatientsData.femaleNumber[2] : '' }}</h4>
                <mat-icon class="woman-ico">woman</mat-icon>
              </div>
            </div>
          </div>
        </div>
      </mat-card>

      <!-- // Tobacco users who were advised to quit card  -->
      <mat-card fxFlex="33%" fxFlex.lt-lg="100%" fxLayout="column">
        <div class="mat-body-1 mb-20">
          TOTAL -
          <span class="fw500">{{ advisedToQuitData.totalPatients }}</span>
        </div>
        <div
          class="primary-dark-text"
          fxLayout
          fxLayoutAlign="start center"
          fxLayoutGap="10px"
          style="height: 20%"
        >
          <h3 fxFlex.lt-lg="15">
            {{ advisedToQuitData.percentage | number: '1.0-0' }}%
          </h3>
          <h6>Tobacco users who were advised to quit</h6>
        </div>
        <div class="mt-10" fxLayout fxLayoutGap="30px">
          <div>
            <p>Yes</p>
            <div class="mat-body-1 mt-10">
              {{ advisedToQuitData.totalNumber ? advisedToQuitData.totalNumber[0]  : ''}} Total
            </div>

            <div fxLayout fxLayoutGap="10px">
              <div fxLayout fxLayoutGap="5px">
                <h4>{{ advisedToQuitData.maleNumber ? advisedToQuitData.maleNumber[0] : '' }}</h4>
                <mat-icon class="man-ico">man</mat-icon>
              </div>
              <div fxLayout fxLayoutGap="5px">
                <h4>{{ advisedToQuitData.femaleNumber ? advisedToQuitData.femaleNumber[0]  : ''}}</h4>
                <mat-icon class="woman-ico">woman</mat-icon>
              </div>
            </div>
          </div>
          <div>
            <p>No</p>
            <div class="mat-body-1 mt-10">
              {{ advisedToQuitData.totalNumber ? advisedToQuitData.totalNumber[1] : ''}} Total
            </div>

            <div fxLayout fxLayoutGap="10px">
              <div fxLayout fxLayoutGap="5px">
                <h4>{{ advisedToQuitData.maleNumber? advisedToQuitData.maleNumber[1] : ''}}</h4>
                <mat-icon class="man-ico">man</mat-icon>
              </div>
              <div fxLayout fxLayoutGap="5px">
                <h4>{{ advisedToQuitData.femaleNumber ? advisedToQuitData.femaleNumber[1] : '' }}</h4>
                <mat-icon class="woman-ico">woman</mat-icon>
              </div>
            </div>
          </div>
        </div>
      </mat-card>

      <!-- // Tobacco users who were ready to quit card  -->
      <mat-card fxFlex="33%" fxFlex.lt-lg="100%" fxLayout="column">
        <div class="mat-body-1 mb-20">
          TOTAL -
          <span class="fw500">{{ readyToQuitData.totalPatients }}</span>
        </div>
        <div
          class="primary-dark-text"
          fxLayout
          fxLayoutAlign="start center"
          fxLayoutGap="10px"
          style="height: 20%"
        >
          <h3 fxFlex.lt-lg="15">
            {{ readyToQuitData.percentage | number: '1.0-0' }}%
          </h3>
          <h6>Tobacco users who were ready to quit</h6>
        </div>
        <div class="mt-10" fxLayout fxLayoutGap="30px">
          <div>
            <p>Yes</p>
            <div class="mat-body-1 mt-10">
              {{ readyToQuitData.totalNumber ? readyToQuitData.totalNumber[0] : ''}} Total
            </div>

            <div fxLayout fxLayoutGap="10px">
              <div fxLayout fxLayoutGap="5px">
                <h4>{{ readyToQuitData.maleNumber ? readyToQuitData.maleNumber[0]  : ''}}</h4>
                <mat-icon class="man-ico">man</mat-icon>
              </div>
              <div fxLayout fxLayoutGap="5px">
                <h4>{{ readyToQuitData.femaleNumber ? readyToQuitData.femaleNumber[0] : '' }}</h4>
                <mat-icon class="woman-ico">woman</mat-icon>
              </div>
            </div>
          </div>
          <div>
            <p>No</p>
            <div class="mat-body-1 mt-10">
              {{ readyToQuitData.totalNumber ? readyToQuitData.totalNumber[1] : ''}} Total
            </div>

            <div fxLayout fxLayoutGap="10px">
              <div fxLayout fxLayoutGap="5px">
                <h4>{{ readyToQuitData.maleNumber ? readyToQuitData.maleNumber[1] : ''}}</h4>
                <mat-icon class="man-ico">man</mat-icon>
              </div>
              <div fxLayout fxLayoutGap="5px">
                <h4>{{ readyToQuitData.femaleNumber ? readyToQuitData.femaleNumber[1] : ''}}</h4>
                <mat-icon class="woman-ico">woman</mat-icon>
              </div>
            </div>
          </div>
        </div>
      </mat-card>
    </div>

    <!-- ================================== // 2nd  ROw ================================== -->
    <div
      fxLayout
      fxLayoutAlign="stretch stretch"
      fxLayout.lt-lg="column"
      fxLayoutAlign.lt-lg="start stretch"
      fxLayoutGap="1.5%"
    >
      <!-- // Tobacco users who developed a quit plan with HCP card  -->
      <mat-card fxFlex="33%" fxFlex.lt-lg="100%" fxLayout="column">
        <div class="mat-body-1 mb-20">
          TOTAL -
          <span class="fw500">{{ hcpPatientsData.registeredPatients }}</span>
        </div>
        <div
          class="primary-dark-text"
          fxLayout
          fxLayoutAlign="start center"
          fxLayoutGap="10px"
          style="height: 20%"
        >
          <h3 fxFlex.lt-lg="15">
            {{ hcpPatientsData.percentage | number: '1.0-0' }}%
          </h3>
          <h6>Tobacco users who developed a quit plan with HCP</h6>
        </div>
        <div class="mt-10" fxLayout fxLayoutGap="30px">
          <div>
            <p>Yes</p>
            <div class="mat-body-1 mt-10">
              {{ hcpPatientsData.totalNumber }} Total
            </div>

            <div fxLayout fxLayoutGap="10px">
              <div fxLayout fxLayoutGap="5px">
                <h4>{{ hcpPatientsData.maleNumber }}</h4>
                <mat-icon class="man-ico">man</mat-icon>
              </div>
              <div fxLayout fxLayoutGap="5px">
                <h4>{{ hcpPatientsData.femaleNumber }}</h4>
                <mat-icon class="woman-ico">woman</mat-icon>
              </div>
            </div>
          </div>
        </div>
      </mat-card>

      <!-- // Tobacco users who were referred by HCP to intensive counselling card  -->
      <mat-card fxFlex="33%" fxFlex.lt-lg="100%" fxLayout="column">
        <div class="mat-body-1 mb-20">
          TOTAL -
          <span class="fw500">{{ hcpToIntensiveData.registeredPatients }}</span>
        </div>
        <div
          class="primary-dark-text"
          fxLayout
          fxLayoutAlign="start center"
          fxLayoutGap="10px"
          style="height: 20%"
        >
          <h3 fxFlex.lt-lg="15">
            {{ hcpToIntensiveData.percentage | number: '1.0-0' }}%
          </h3>
          <h6>
            Tobacco users who were referred by HCP to intensive counselling
          </h6>
        </div>
        <div class="mt-10" fxLayout fxLayoutGap="30px">
          <div>
            <p>Yes</p>
            <div class="mat-body-1 mt-10">
              {{ hcpToIntensiveData.totalNumber }} Total
            </div>

            <div fxLayout fxLayoutGap="10px">
              <div fxLayout fxLayoutGap="5px">
                <h4>{{ hcpToIntensiveData.maleNumber }}</h4>
                <mat-icon class="man-ico">man</mat-icon>
              </div>
              <div fxLayout fxLayoutGap="5px">
                <h4>{{ hcpToIntensiveData.femaleNumber }}</h4>
                <mat-icon class="woman-ico">woman</mat-icon>
              </div>
            </div>
          </div>
        </div>
      </mat-card>

      <!-- // Tobacco users who developed a quit plan and prescribed NRTs card  -->
      <mat-card fxFlex="33%" fxFlex.lt-lg="100%" fxLayout="column">
        <div class="mat-body-1 mb-20">
          TOTAL -
          <span class="fw500">{{ prescribedNrtsData.registeredPatients }}</span>
        </div>
        <div
          class="primary-dark-text"
          fxLayout
          fxLayoutAlign="start center"
          fxLayoutGap="10px"
          style="height: 20%"
        >
          <h3 fxFlex.lt-lg="15">
            {{ prescribedNrtsData.percentage | number: '1.0-0' }}%
          </h3>
          <h6>Tobacco users who developed a quit plan and prescribed NRTs</h6>
        </div>
        <div class="mt-10" fxLayout fxLayoutGap="30px">
          <div>
            <p>Yes</p>
            <div class="mat-body-1 mt-10">
              {{ prescribedNrtsData.totalNumber }} Total
            </div>

            <div fxLayout fxLayoutGap="10px">
              <div fxLayout fxLayoutGap="5px">
                <h4>{{ prescribedNrtsData.maleNumber }}</h4>
                <mat-icon class="man-ico">man</mat-icon>
              </div>
              <div fxLayout fxLayoutGap="5px">
                <h4>{{ prescribedNrtsData.femaleNumber }}</h4>
                <mat-icon class="woman-ico">woman</mat-icon>
              </div>
            </div>
          </div>
        </div>
      </mat-card>
    </div>

    <!-- ================================== // 3rd  ROw ================================== -->
    <div
      fxLayout
      fxLayoutAlign="stretch stretch"
      fxLayout.lt-lg="column"
      fxLayoutAlign.lt-lg="start stretch"
      fxLayoutGap="1.5%"
    >
      <!-- // Intensive counselling & NRT card  -->
      <mat-card fxFlex="66%" fxFlex.lt-lg="100%" fxLayout="column">
        <div
          class="primary-dark-text"
          fxLayout
          fxLayoutAlign="start start"
          fxLayoutGap="10px"
        >
          <div fxFlex fxLayoutGap="30px" fxLayout="column">
            <div fxLayout fxLayoutAlign="start center" fxLayoutGap="10px">
              <h3 fxFlex="9" fxFlex.lt-lg="15">
                {{ tobaccoFreeData ? tobaccoFreeData.overallCount : '' }}
              </h3>
              <div fxFlex fxLayoutGap="5px" fxLayout="column">
                <h6>Tobacco-free in 6 months</h6>
                <h5>
                  Split by intensive counselling & NRT (Nicotine replacement
                  therapy)
                </h5>
              </div>
            </div>

            <div fxLayout="column" fxLayoutGap="-4px">
              <div
                fxFlex
                fxLayout="row"
                fxLayoutGap="10px"
                fxFlexAlign="start center"
              >
                <div><mat-icon style="color: #5cbdfc">square</mat-icon></div>
                <p>
                  {{
                    tobaccoFreeData && tobaccoFreeData.noReferralToIntensive
                      ? tobaccoFreeData.noReferralToIntensive[0].totalNumber
                      : ''
                  }}
                  without referral to counselling
                </p>
              </div>

              <div
                fxFlex
                fxLayout="row"
                fxLayoutGap="10px"
                fxFlexAlign="start center"
              >
                <div><mat-icon style="color: #006098">square</mat-icon></div>
                <p>
                  {{ 
                    tobaccoFreeData && tobaccoFreeData.referralToIntensive
                      ? tobaccoFreeData.referralToIntensive[0].totalNumber
                      : ''
                  }}
                  referred but not offered NRT
                </p>
              </div>

              <div
                fxFlex
                fxLayout="row"
                fxLayoutGap="10px"
                fxFlexAlign="start center"
              >
                <div><mat-icon style="color: #d86422">square</mat-icon></div>
                <p>
                  {{
                    tobaccoFreeData && tobaccoFreeData.referralWithNrt
                      ? tobaccoFreeData.referralWithNrt[0].totalNumber
                      : ''
                  }}
                  referred and offered NRT
                </p>
              </div>
            </div>
          </div>

          <!-- Chart -->
          <div style="position: relative; top: -10px">
            <canvas width="200" height="200" #pieChartMain id="myPieChart">
            </canvas>
          </div>
        </div>
        <div>
          <!-- ====================     Split by gender table ===============  -->
          <div style="background-color: lightgrey; height: 2px"></div>
          <br />
          <div fxLayout fxLayoutGap="15px">
            <h6
              
              style="cursor: pointer"
              (click)="toggleSplit()"
              class="primary-dark-text"
            >
              SPLIT BY GENDER
            </h6>
            <div>
              <mat-icon style="cursor: pointer;" (click)="toggleSplit()">{{
                showSplitByGender ? 'expand_less' : 'expand_more'
              }}</mat-icon>
            </div>
          </div>
          <!-- ====================     Split by gender table ===============  -->
          <div *ngIf="showSplitByGender" class="mt-10">
            <div
              fxLayout="row"
              fxLayoutGap="70px"
              fxLayoutAlign="start flex-end"
            >
              <!-- Headers -->
              <div fxLayout="column" fxLayoutGap="20px" class="ageGroup">
                <span style="color: rgba(0, 0, 0, 0.8)">Total</span>
                <mat-icon class="man-ico">man</mat-icon>
                <mat-icon class="woman-ico">woman</mat-icon>
              </div>

              <!-- No referral -->
              <div
                fxLayout="column"
                fxLayoutGap="20px"
                fxLayoutAlign="center center"
                class="columnHeaders"
              >
                <span style="color: rgba(0, 0, 0, 0.8)">No referral</span>
                <div>
                  {{
                    tobaccoFreeData
                      ? tobaccoFreeData.noReferralToIntensive[0].totalNumber
                      : ''
                  }}
                </div>
                <div>
                  {{
                    tobaccoFreeData
                      ? tobaccoFreeData.noReferralToIntensive[0].maleNumber
                      : ''
                  }}
                </div>
                <div>
                  {{
                    tobaccoFreeData
                      ? tobaccoFreeData.noReferralToIntensive[0].femaleNumber
                      : ''
                  }}
                </div>
              </div>

              <div
                fxLayout="column"
                fxLayoutGap="20px"
                fxLayoutAlign="center center"
                class="columnHeaders"
              >
                <span style="color: rgba(0, 0, 0, 0.8)">Referred</span>
                <div>
                  {{
                    tobaccoFreeData
                      ? tobaccoFreeData.referralToIntensive[0].totalNumber
                      : ''
                  }}
                </div>
                <div>
                  {{
                    tobaccoFreeData
                      ? tobaccoFreeData.referralToIntensive[0].maleNumber
                      : ''
                  }}
                </div>
                <div>
                  {{
                    tobaccoFreeData
                      ? tobaccoFreeData.referralToIntensive[0].femaleNumber
                      : ''
                  }}
                </div>
              </div>

              <div
                fxLayout="column"
                fxLayoutGap="20px"
                fxLayoutAlign="center center"
                class="columnHeaders"
              >
                <span style="color: rgba(0, 0, 0, 0.8)">Referred + NRT</span>
                <div>
                  {{
                    tobaccoFreeData
                      ? tobaccoFreeData.referralWithNrt[0].totalNumber
                      : ''
                  }}
                </div>
                <div>
                  {{
                    tobaccoFreeData
                      ? tobaccoFreeData.referralWithNrt[0].maleNumber
                      : ''
                  }}
                </div>
                <div>
                  {{
                    tobaccoFreeData
                      ? tobaccoFreeData.referralWithNrt[0].femaleNumber
                      : ''
                  }}
                </div>
              </div>

              <div
                fxLayout="column"
                fxLayoutGap="20px"
                fxLayoutAlign="center center"
                class="columnHeaders"
              >
                <span style="color: rgba(0, 0, 0, 0.8)">Total</span>
                <!-- <p *ngFor="let item of tobaccoFreeData.femaleList">{{ item }}</p> -->
                <div>
                  {{
                    tobaccoFreeData.noReferralToIntensive[0].totalNumber +
                      tobaccoFreeData.referralToIntensive[0].totalNumber +
                      tobaccoFreeData.referralWithNrt[0].totalNumber
                  }}
                </div>
                <div>
                  {{
                    tobaccoFreeData
                      ? tobaccoFreeData.noReferralToIntensive[0].maleNumber +
                        tobaccoFreeData.referralToIntensive[0].maleNumber +
                        tobaccoFreeData.referralWithNrt[0].maleNumber
                      : ''
                  }}
                </div>
                <div>
                  {{
                    tobaccoFreeData
                      ? tobaccoFreeData.noReferralToIntensive[0].femaleNumber +
                        tobaccoFreeData.referralToIntensive[0].femaleNumber +
                        tobaccoFreeData.referralWithNrt[0].femaleNumber
                      : ''
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-card>
    </div>
  </section>
</div>
